var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-scrollbar",
    { attrs: { "wrap-class": "scrollbar-wrapper" } },
    [
      _c(
        "div",
        { staticClass: "brand" },
        [
          _vm.isOpened
            ? _c("img", {
                attrs: { src: require("../../../../assets/image/logo.png") }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isOpened ? _c("div", [_vm._v("工单系统")]) : _vm._e(),
          _vm._v(" "),
          _c("hamburger", {
            staticClass: "hamburger-container",
            attrs: {
              "toggle-click": _vm.toggleSideBar,
              isActive: _vm.sidebar.opened
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-menu",
        {
          ref: "menu",
          attrs: {
            "show-timeout": 200,
            "default-active": _vm.$route.path,
            collapse: _vm.isCollapse,
            mode: "vertical",
            "background-color": "#fff",
            "text-color": "#34383D",
            "active-text-color": "#671E75"
          }
        },
        _vm._l(_vm.permission_routers, function(route) {
          return _c("sidebar-item", {
            key: route.path,
            attrs: {
              activeName: _vm.activeName,
              item: route,
              "base-path": route.path
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }